module.exports = __webpack_public_path__ + "src/assets/vehicles/bike-veo.svg";